import { CommonEnums } from '../../common.enums';

export class Venn_Grp {
    venn_Grp_Id: number;
    venn_Inst_Id: number;
    dxMp_Id: number;
    grpNm: string;
    grpOperTxt: string;
    srt_Order: number;
    secObjId: number;
    // valid_Cd: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.venn_Grp_Id = CommonEnums.defaults.LONG_VAL;
        this.venn_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.grpNm = CommonEnums.defaults.STRING_EMPTY;
        this.grpOperTxt = CommonEnums.defaults.STRING_EMPTY;
        this.srt_Order = CommonEnums.defaults.LONG_VAL;
        this.secObjId = CommonEnums.defaults.LONG_VAL;
        // this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
    }

    static parse(venn_GrpTmp: Venn_Grp): Venn_Grp {
        let venn_Grp: Venn_Grp = new Venn_Grp();
        venn_Grp.copyFrom(venn_GrpTmp);
        return venn_Grp;
    }

    getPrimaryKey(): string {
        return this.venn_Grp_Id + '.' + this.venn_Inst_Id + '.' + this.dxMp_Id;
    }

    copy(): Venn_Grp {
        let venn_GrpTmp: Venn_Grp = new Venn_Grp();

        venn_GrpTmp.venn_Grp_Id = this.venn_Grp_Id;
        venn_GrpTmp.venn_Inst_Id = this.venn_Inst_Id;
        venn_GrpTmp.dxMp_Id = this.dxMp_Id;
        venn_GrpTmp.grpNm = this.grpNm;
        venn_GrpTmp.grpOperTxt = this.grpOperTxt;
        venn_GrpTmp.srt_Order = this.srt_Order;
        venn_GrpTmp.secObjId = this.secObjId;

        return venn_GrpTmp;
    }

    copyFrom(venn_GrpTmp: Venn_Grp): void {
        this.venn_Grp_Id = venn_GrpTmp.venn_Grp_Id;
        this.venn_Inst_Id = venn_GrpTmp.venn_Inst_Id;
        this.dxMp_Id = venn_GrpTmp.dxMp_Id;
        this.grpNm = venn_GrpTmp.grpNm;
        this.grpOperTxt = venn_GrpTmp.grpOperTxt;
        this.srt_Order = venn_GrpTmp.srt_Order;
        this.secObjId = venn_GrpTmp.secObjId;
    }

    compare(venn_GrpTmp: Venn_Grp): string {
        let venn_GrpString: string = this.toString(false);
        let venn_GrpTmpString: string = venn_GrpTmp.toString(false);

        if (venn_GrpString != venn_GrpTmpString) {
            return venn_GrpTmp + ',' + venn_GrpTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Venn_Grp [venn_Grp_Id=" + this.venn_Grp_Id + ", venn_Inst_Id=" + this.venn_Inst_Id +
            ", dxMp_Id=" + this.dxMp_Id + ", grpNm=" + this.grpNm + ", grpOperTxt=" + this.grpOperTxt +
            ", srt_Order=" + this.srt_Order + ", secObjId=" + this.secObjId;

        if (isNotCompare) {
            str += ''
        }

        str += ']';
        return str;
    }
}
